import { registerDavProperty } from '@nextcloud/files/dav';
/**
 *
 */
export function initLivePhotos() {
    registerDavProperty('nc:metadata-files-live-photo', { nc: 'http://nextcloud.org/ns' });
}
/**
 * @param node - The node
 */
export function isLivePhoto(node) {
    return node.attributes['metadata-files-live-photo'] !== undefined;
}
